exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.images .v-window__container[data-v-0a3feb1b] {\n  height: 100% !important;\n}\n", ""]);

// exports
